
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import './i18n'
import './assets/css/custom.css';
import App from './App';
import "flag-icons/css/flag-icons.min.css";

const root = ReactDOMClient.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);